import type { FaireProductEntity } from "../../entity_types/product";

export const p_67r23q3gye: FaireProductEntity = {
  token: "p_67r23q3gye",
  type: "product",
  name: "Double-layer necklace, cubic zirconia, stainless steel, 18K gold PVD",
  brandToken: "b_3t5pew5dxb",
  brandName: "Minimalistajoyeria",
  imageUrl:
    "https://cdn.faire.com/fastly/9f893a61d174b31cfadfba11b63e234b3e55982d771814140d8b52dd69d39051.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/796fd387537c9c53bbf75de8ce6a16c08d2d2f6bfc4a5b2b02b3e4aa75d7e9b4.jpeg",
    "https://cdn.faire.com/fastly/f5811f408b854f91b0c5cf827984efcc725bc7691fa450e503670058c093d670.jpeg",
    "https://cdn.faire.com/fastly/aac3115c0732af3f844c172abc2a1366e54a4e696da974050c5dcf9f6650a351.jpeg",
    "https://cdn.faire.com/fastly/6b865f6121ca58507f114f64f525879dd939208c871ae580209d541f9649e108.jpeg",
    "https://cdn.faire.com/fastly/6d482df60e2c27aac1b45cf9a52e0d0493712aacd8286bda5dcefa1f6df65acb.jpeg",
  ],
  priceDollars: 8.78,
  description:
    "Premium stainless steel necklace with a two-layer chain and white cubic zirconia pendants\n\nPremium Material: Stainless steel with 18K vacuum gold plating (PVD Waterproof); water-resistant, durable and does not fade.\nFinish: High-gloss polish\nHypoallergenic: Safe for sensitive skin; does not stain or irritate.\nApproximate size, with adjustable extender\n\nStock in Spain: Fast shipping and no customs.\n\nDirect Price: Luxury look at factory price.",
  tags: [],
  msrpDollars: 17.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:40.120Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
